// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3Sc-H","header":"PatientQuestionnaire_header__1Xvgh","info":"PatientQuestionnaire_info__2k1v_"};